module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "widthRef"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row table-search-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.apps.length) + " apps found from\n      " + _vm._s(_vm.$parent.$parent.baseUrl) + "/helium/api/v2/app\n    ")])]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "title": "",
      "columns": _vm.columns,
      "rows": _vm.apps,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'name',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.id) + "\n      ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'fqdn') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.fqdn) + "\n      ")]) : _vm._e(), _vm._v(" "), (props.column.label == 'Actions') ? _c('span', [_c('button', {
          staticClass: "btn btn-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.view(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-chart-pie",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" View\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.config(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-wrench",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Config\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.logs(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-history",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Logs\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-error",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.scheduledfunctions(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-tasks",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Scheduled Functions\n          ")])]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Visualize db performance and scheduled functions results")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chart-pie card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Set timeout values for scheduled functions and views")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-wrench card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Stream Helium app logs directly to your browser")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-history card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-624594c9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Apps.vue
// module id = 591
// module chunks = 2